import { ChatService } from '@app/+chat/services/chat.service';
import { Directive, HostListener, Input, OnInit, OnDestroy } from '@angular/core';
import { Product } from '@vestiaire/api-sdk-angular';
import { IsLoggedGuard } from '@app/shared/guards';
import { MatDialog } from '@angular/material/dialog';
import { Overlay } from '@angular/cdk/overlay';
import { ChatDiscussionComponent } from '@app/+chat/components/chat-discussion/chat-discussion.component';
import { Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { getUser } from '@app/core/user/store/reducers';
import { filter } from 'rxjs/operators';
import { IAppState } from '@app/store';
import { Router, NavigationStart } from '@angular/router';

@Directive({
  selector: '[appOpenChatPopin]'
})
export class OpenChatPopinDirective implements OnInit, OnDestroy {
  @Input()
  product: Product;
  @Input()
  chatFromPdp: boolean;
  channelID: string;
  storeListener: Subscription;
  dialogRef: any;

  constructor(
    private modal: MatDialog,
    private loggedGuard: IsLoggedGuard,
    private store: Store<IAppState>,
    private chatService: ChatService,
    private overlay: Overlay,
    private router: Router
  ) {}

  ngOnInit() {
    this.storeListener = this.store.pipe(select(getUser), filter(Boolean)).subscribe({
      next: ({ id }) => {
        this.channelID = this.product.seller.id !== id ? `${id}-${this.product.id}` : '';
      }
    });
    this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(
      (event: NavigationStart) => {
        if (this.dialogRef) {
          this.dialogRef.close();
        }
      },
      error => console.log(error)
    );
  }

  ngOnDestroy() {
    this.storeListener.unsubscribe();
  }

  @HostListener('click', ['$event'])
  openPopinAlert() {
    if (this.loggedGuard.isLoggedIn()) {
      // prevent multiple popins
      if (!this.dialogRef) {
        this.dialogRef = this.modal.open(ChatDiscussionComponent, {
          disableClose: false,
          panelClass: 'reset-position-mobile-modal',
          hasBackdrop: false,
          width: '375px',
          position: { right: '1.25rem', bottom: '1.25rem' },
          data: {
            product: this.product,
            channelID: this.channelID,
            chatFromPdp: this.chatFromPdp
          },
          restoreFocus: false,
          scrollStrategy: this.overlay.scrollStrategies.noop()
        });
      }

      this.dialogRef.afterClosed().subscribe(
        () => {
          this.dialogRef = undefined;
          this.chatService.logout();
        },
        err => {
          // Silently fails
        }
      );
    }
  }
}
